import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthserviceService } from '../services/authservice.service';
import { TermsAndServiceCheckService } from '../components/terms-and-service-modal/terms-and-service-check.service';

/**
 * Functional guard to protect routes that require authentication.
 * Redirects to login page if user is not authenticated.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthserviceService);

  if (!authService.isLoggedIn()) {
    router.navigate(['login']);
    return false;
  }

  // Fire-and-forget: prompts the mandatory Terms of Service modal when the
  // latest version hasn't been agreed to yet. Does not block navigation.
  // Temporarily disabled — uncomment to re-enable the Terms of Service modal check.
  // inject(TermsAndServiceCheckService).checkAndPrompt();

  return true;
};

/**
 * @deprecated Use authGuard instead. This class-based guard will be removed in future versions.
 * Kept for backward compatibility during migration.
 */
export const AuthGuard = authGuard;
